import { Flex, Text } from "@gravity-ui/uikit";
import { motion, type MotionProps } from "framer-motion";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { Counter, CounterProps } from "../Counter";
import { animation } from "./AdvantageCard.constants";
import css from "./AdvantageCard.module.scss";

interface AdvantageCardProps extends React.PropsWithChildren {
  title: string;
  counter?: CounterProps;
  description: string;
  animate?: MotionProps;
}

export const AdvantageCard = ({
  title,
  description,
  counter,
  animate,
  children,
}: AdvantageCardProps) => {
  const { deviceText } = useGravityDevice();

  return (
    <motion.div
      {...animation}
      {...animate}
      className={css.advantageCardContainer}
    >
      <Flex alignItems={"center"} justifyContent={"center"}>
        {children}
      </Flex>
      <Flex direction={"column"}>
        <Text variant={deviceText.subheader} as="h2">
          {title}
        </Text>
        {counter && (
          <Text variant={deviceText.header} style={{ lineHeight: 0 }}>
            <Counter {...counter} />
          </Text>
        )}
      </Flex>

      <Text
        variant="body-1"
        color="hint"
        style={{ maxWidth: "fit-content" }}
        as="h3"
      >
        {description}
      </Text>
    </motion.div>
  );
};
